<template>
  <main class="page-companies-index">
    <div class="container">
      <PageTitle class="mb-3">Aziende</PageTitle>

      <div class="filters w-50 row ml-auto d-flex flex-row-reverse mb-2">
        <FormInputSelectWidget
          notRequired
          @input="onFilterChange"
          class="col-md-3 mb-4 px-2"
          label="Stato"
          placeholder="-"
          v-model="filters.status"
          :options="availableStatus"
        />
        <FormInputSelectWidget
          notRequired
          @input="onFilterChange"
          class="col-md-3 mb-4"
          label="Setup"
          placeholder="-"
          v-model="filters.setup"
          :options="availableSetups"
        />
        <FormInputSelectWidget
          v-if="$oauth2.me.admin"
          notRequired
          @input="onFilterChange"
          class="col-md-6 mb-4"
          label="Supervisor"
          placeholder="Seleziona un supervisor"
          v-model="filters.consultant"
          :options="consultantsFiltered"
        />
      </div>
      <Loading v-if="isLoading" class="wrapper centered" />
      <div v-else-if="companiesWithDisabledStatus.length > 0">
        <div class="row">
          <div class="col-md-6 mb-4" v-for="(company, index) in companiesWithDisabledStatus" :key="index">
            <LawaCard :name="company.name">
              <template #header>
                <p class="text-uppercase text-right mb-0">
                  <span class="d-block small font-weight-light text-muted">Stato</span>
                  <span :class="[{ 'text-danger' : company.disabled }, { 'text-success' : !company.disabled }, { 'text-warning small' : company.daysBeforeDisabled != null }]">
                    {{ company.disablingStateName }}
                  </span>
                </p>
              </template>
              <h4 class="font-weight-bold truncated-text" :title="company.name">{{ company.name }}</h4>
              <p class="small text-uppercase mb-1">
                <strong>P.IVA:</strong>
                {{ company.vat }}
              </p>
              <p class="small text-uppercase mb-1" v-if="$oauth2.me && $oauth2.me.admin">
                <strong>Consulente:</strong>
                {{ company.consultant.name + ' ' + company.consultant.surname }}
              </p>
              <p class="small text-uppercase mb-1">
                <strong>Setup:</strong>
                {{ company.hasBeenSetup ? 'Effettuato' : 'Non effettuato' }}
              </p>
              <template #footer>
                <AwlConfirm
                  v-if="company.canBeEnabled || company.canBeDisabled"
                  :status="company.canBeDisabled ? 'outline-danger btn-sm' : 'outline-success btn-sm'"
                  :title="company.canBeDisabled ? 'Disattiva' : 'Attiva'"
                  @open="disable = 0"
                  @confirm="onConfirm($event, company)"
                >
                  Sei sicuro di voler {{ company.canBeDisabled ? 'disattivare' : 'attivare'}} l'azienda {{company.name}}?
                  <FormInputSelectWidget
                    class="col-12 col-md-6 col-lg-4 px-0"
                    label="Quando?"
                    v-model="disable"
                    v-if="company.canBeDisabled"
                    :options="disableValues"
                  />
                </AwlConfirm>

                <router-link class="btn btn-primary btn-sm" :to="{ name: 'companies-show', params: { id: company.id } }">
                  Visualizza
                </router-link>
              </template>
            </LawaCard>
          </div>
        </div>
        <div class="d-flex mt-3 mb-5">
          <b-pagination
            v-model="currentPage"
            :total-rows="paginationMetadata['total-items']"
            :per-page="paginationMetadata['per-page']"
          ></b-pagination>
        </div>
      </div>
      <template v-else>
        <AlertFeedback status="info">
          <h4 class="alert-heading">Nessuna azienda disponibile</h4>
          <p v-if="noFiltersSelected">Non sono presenti aziende disponibili. Inizia aggiungendone una!</p>
          <p v-else>La ricerca non ha prodotto alcun risultato</p>
          <hr>
          <div class="text-right">
            <button class="btn btn-outline-primary" @click="goToCreate()">
              Aggiungi azienda
            </button>
          </div>
        </AlertFeedback>
      </template>
    </div>
    <div class="fab-container">
      <AwlFabAddButton class="ml-auto" @click="goToCreate()" title="Nuova azienda" />
    </div>
  </main>
</template>

<script>
import { BPagination } from 'bootstrap-vue';
import Loading from '@/views/components/Layout/Loading';
import $api from '../../../../libs/Api/services/api';

export default {
  name: 'page-companies-index',
  components: {
    AwlConfirm: () => import('../../../../libs/Modals/components/AwlConfirm'),
    AwlFabAddButton: () => import('../../../components/Ui/AwlFabAddButton'),
    BPagination,
    Loading,
    FormInputSelectWidget: () => import('../../../../libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    LawaCard: () => import('../../../components/Layout/Card/LawaCard'),
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    AlertFeedback: () => import('../../../../libs/Feedback/components/Alert'),
  },
  data () {
    return {
      filters: {
        status: this.$route?.query?.status ?? null,
        setup: this.$route?.query?.setup ?? null,
        consultant: this.$route?.query?.consultant ?? null,
      },
      availableSetups: [
        { value: 'done', label: 'Effettuato' },
        { value: 'not-done', label: 'Non effettuato' },
        { value: null, label: 'Tutti' },
      ],
      availableStatus: [
        { value: 'active', label: 'Attivi' },
        { value: 'disabling', label: 'In disattivazione' },
        { value: 'disabled', label: 'Non Attivi' },
        { value: null, label: 'Tutti' },
      ],
      paginationMetadata: {
        'per-page': 1,
        'total-items': 1,
      },
      isLoading: true,
      currentPage: this.$route?.query?.page ?? 1,
      companies: [],
      consultants: [],
      disable: 0,
      disableValues: [
        { value: 0, label: 'Oggi' },
        { value: 3, label: 'Tra 3 giorni' },
        { value: 7, label: 'Tra 7 giorni' },
        { value: 15, label: 'Tra 15 giorni' },
      ],
    };
  },
  computed: {
    noFiltersSelected () {
      return Object.values(this.filters).every(x => x === null || x === '');
    },
    consultantsFiltered () {
      let consultants = [...this.consultants];
      consultants = consultants.map(c => {
        const p = {};
        p.label = `${c.name} ${c.surname}`;
        p.value = c.id;
        return p;
      });
      consultants.push({ label: 'Tutti', value: null });
      return consultants;
    },
    companiesWithDisabledStatus () {
      return this.companies.map(c => {
        c.canBeDisabled = false;
        c.canBeEnabled = false;
        if (c.disabledBecauseConsultant) {
          c.disablingStateName = 'Disattivata per consulente';
        } else if (c.daysBeforeDisabled === 1) {
          c.disablingStateName = 'In disattivazione fra un giorno';
          c.canBeEnabled = true;
        } else if (c.daysBeforeDisabled) {
          c.disablingStateName = 'In disattivazione fra ' + c.daysBeforeDisabled + ' giorni';
          c.canBeEnabled = true;
        } else if (c.disabled) {
          c.disablingStateName = 'Disattivata';
          c.canBeEnabled = true;
        } else {
          c.disablingStateName = 'Attiva';
          c.canBeDisabled = true;
        }

        return c;
      });
    },
  },
  mounted () {
    this.getCompanies();
    this.currentPage = this.$route?.query?.page ?? 1;
  },
  methods: {
    onFilterChange () {
      this.currentPage = 1;
      this.$router.replace({
        query: Object.assign({}, this.$route.query, this.filters),
      });
    },
    getCompanies () {
      this.isLoading = true;
      $api.companies(this.$route.query)
        .then((res) => {
          this.companies = res.data?.companies || [];
          this.paginationMetadata = res.data?.metadata || {};
        })
        .catch((err) => {
          this.$log.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async onConfirm (event, company) {
      try {
        if (company.canBeDisabled) {
          await this.$api.disableCompany(company.id, this.disable);
        } else {
          await this.$api.enableCompany(company.id);
        }
        this.getCompanies();
      } catch (err) {
        this.$log.error(err);
      }
    },
    goToCreate () {
      this.$router.push({ name: 'companies-create' });
    },
  },
  created () {
    if (this.$oauth2.me.admin) {
      this.$api.consultants(false)
        .then((res) => {
          this.consultants = res.data?.consultants || [];
        })
        .catch((err) => {
          this.log.error(err);
        });
    }
  },
  watch: {
    currentPage: function (val) {
      this.$router.replace({
        query: Object.assign({}, this.$route.query, { page: val }),
      });
    },
    $route: function () {
      this.getCompanies();
    },
  },
};

</script>

<style lang="scss">

.page-companies-index {
  .awl-card {
    .awl-card--content {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

</style>
